export const loggedIn = state => state.login && Date.now() < state.login_until;

export const jwtToken = state => state.jwt_token;

export const canDo = state => permission => {
  if (!state.user) return 0;
  return state.user.permissions.filter(ele => ele === permission).length;
};

export const filteredMenu = (state, getters) => menu => {
  let filtered = [];
  menu.forEach( item => {
    let {text, icon, to, permissions, group, children} = item;
    if( children ) {
      const c = getters.filteredMenu(children);
      if( c.length > 0 ) {
        filtered.push( {
          text,icon,to,permissions,group,
          children: c,
        });
      }
    } else {
      if( item.permissions && item.permissions.every(p => getters.canDo(p)) ) {
        filtered.push({ text,icon,to,permissions });
      }
    }
  });
  return filtered;
}